import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js';
import {
  BasicSelect
} from 'vue-search-select';
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'

export default {
  name: 'RackMaster',
  components: {
    Paginate,
    BasicSelect,
    VueElementLoading
  },
  props: [],
  data() {
    return {
      hubzoneLoading: '',
      isLoading: false,
      isLoadingSearch: false,
      IsActive: false,
      statusmodal: false,
      activeHubList: [],
      HubDetails: [],
      hublist: [],
      RackListData: [],
      hubitem: {
        value: '',
        text: ''
      },
      hub: '',
      rack: '',
      hubLoading: '',
      modaldata: '',
      createdby: '',
      pageCount: 0,
      pageNo: 0,
      totalRecords: 0,
      hubzonelist: [],
      hubzoneitem: {
        id: '',
        text: ''
      },
      hubzone: '',
      pageCount: 0,
      pageNo: 0,
      totalRows: 0,
      limit: 10,
      userHubid: '',
			updateModal:false,
			modaldata:'',
      rackNumberForUpdate:'',
      rackNoError:false,
      rackNoErrorMSG:'',
      regexForRackId:/^[a-zA-Z0-9]{1,30}$/,
      listHubZoneObjDataFlt1: {
        value: '',
        text: ''
      },
      hubzoneidflt1: '',
      hubitemFlt: {
        value: '',
        text: ''
      },
      hubFlt: '',
      hublistFlt:[],
      hubzoneitemForUpdate:{
        value: '',
        text: ''
      },
      hubZoneForUpdate:'',
      HubDetailsForUpdate:[],
      hubItemForUpdate:{
        value: '',
        text: ''
      },
      hubNameForUpdate:'',
      statusmodal:false,
      modalDataForStatus:[]
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdby = userdetail[0].email
    this.userHubid = userdetail[0].HubId[0]
    // this.getRackList();
    this.getHubZone();
  },
  methods: {
    selectHubForUpdate(hubitem) {
      this.hubItemForUpdate = hubitem
      this.hubNameForUpdate = hubitem.value
    },
    selectHubZoneForUpdate(hubzoneitem) {
      this.hubzoneitemForUpdate = hubzoneitem
      this.hubZoneForUpdate = this.hubzoneitemForUpdate.id
      this.hublist = []
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hub = ''
      this.$validator.reset()
      if (this.hubZoneForUpdate != undefined) {
        this.getHubListForUpdate()
      }
    },
    selectHubFlt(hubitem) {
      this.hubitemFlt = hubitem
      this.hubFlt = hubitem.value
    },
    selectedHubZoneFlt1(listHubZoneObjDataFlt1) {
      this.listHubZoneObjDataFlt1 = listHubZoneObjDataFlt1
      this.hubzoneidflt1 = listHubZoneObjDataFlt1.text
      this.hubzoneid = listHubZoneObjDataFlt1.id
      this.hublistFlt = []
      this.hubitemFlt = {
        value: '',
        text: ''
      }
      this.hubFlt = ''
      this.$validator.reset()
      if (this.hubzoneid != undefined) {
        this.getHubList('IsSearch')
      }
    },
    getRackList() {
      this.isLoadingSearch = true;
      this.input = ({});
      this.RackListData = []
        axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'listRackMaster?limit=' + this.limit + '&offset=' + this.pageNo+'&hubId='+this.hubFlt,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
					if(result.data.ResultCode == 100){
						this.RackListData = result.data.ResponseData;
						this.totalRows = result.data.TotalCount
						if (this.totalRows < 10) {
							this.pageCount = 1
						} else {
							this.pageCount = Math.ceil(this.totalRows / 10);
						}
					}
					else{
						this.RackListData = []
						this.totalRows = 0
						this.$alertify.error(result.data.ReturnMessage)
					}
        }, error => {
          console.error(error)
        })
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getRackList()
    },
    resetForm() {
      this.rackNoError=false;
      this.rackNoErrorMSG="";
      this.totalRows = 0;
      this.pageCount = 0;
      this.hubzone = "";
      this.hub = "";
      this.rack = "";
      this.hubzoneitem = {
          id: '',
          text: ''
        },
        this.hubitem = {
          value: '',
          text: ''
        },
        this.$validator.reset();
    },
    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var HubZoneListData = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
          HubZoneListData = result.data.ResponseData;
          for (var i = 0; i < HubZoneListData.length; i++) {
            this.hubzonelist.push({
              id: HubZoneListData[i].hubzoneid,
              text: HubZoneListData[i].hubzonename
            })
          }
        }
        else{
          HubZoneListData = []
        }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })
    },

    selectHubZone(hubzoneitem) {
      this.hubzoneitem = hubzoneitem
      this.hubzone = this.hubzoneitem.text
      this.hubzoneid = this.hubzoneitem.id
      this.hublist = []
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hub = ''
      this.$validator.reset()
      if (this.hubzoneid != undefined) {
        this.getHubList()
      }
    },

    getHubList() {
      this.hubLoading = 'Loading Hub...'
      var HubDetails = []
      this.hublistFlt=[]
      this.input = ({
        hubZoneId: this.hubzoneid
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          if (result.data.ResultCode == 100) {
            HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.hublist.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
            this.hublistFlt.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })
          }
        }else{
          HubDetails = []
        }
        }, error => {
          this.hubLoading = ''
          console.error(error)
        })
    },
    getHubListForUpdate() {
      this.hubLoading = 'Loading Hub...'
      var HubDetails = []
      this.HubDetailsForUpdate=[]
      this.input = ({
        hubZoneId: this.hubZoneForUpdate
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          if (result.data.ResultCode == 100) {
            HubDetails = result.data.ResponseData
          for (var i = 0; i < HubDetails.length; i++) {
            this.HubDetailsForUpdate.push({
              "value": HubDetails[i].HubID,
              "text": HubDetails[i].HubName + '(' + HubDetails[i].HubID + ')',
            })

          }
        }else{
          HubDetails = []
        }
        }, error => {
          this.hubLoading = ''
          console.error(error)
        })
    },

    selectHub(hubitem) {
      this.hubitem = hubitem
      this.hub = hubitem.value
    },
    saveRack() {
      this.rackNoError=false;
      this.rackNoErrorMSG="";
      if(this.rack && this.regexForRackId.test(this.rack) == false)
      {
        this.rackNoError=true;
        this.rackNoErrorMSG="Bin Number Must Be AlphaNumeric";
        return false;
      }
      this.isLoading = true;

      this.input = ({
        "rackName": this.rack,
        "createdBy": this.createdby,
        "hubId":this.hub
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'addBinRack',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            // this.getRackList()
            this.resetForm();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
    updateRack() {
      this.rackNoError=false;
      this.rackNoErrorMSG="";
      if(!this.rackNumberForUpdate)
      {
        this.rackNoError=true;
        this.rackNoErrorMSG="Enter Rack Number";
        return false;
      }
      if(this.rackNumberForUpdate && this.regexForRackId.test(this.rackNumberForUpdate) == false)
      {
        this.rackNoError=true;
        this.rackNoErrorMSG="Rack Number Must Be AlphaNumeric";
        return false;
      }
      console.log(this.hubItemForUpdate.value,"this.hubNameForUpdate");
      this.input = ({
        "rackMasterId": this.modaldata.rackmasterid,
        "rackName": this.rackNumberForUpdate,
        "isActive": this.modaldata.isactive,
        "LastModifiedBy": this.createdby,
        "hubId":this.hubItemForUpdate.value
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateRack',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeUpdateRackModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
		openUpdateRackModal(data){
			this.updateModal = true
			this.modaldata = data

      this.hubzoneLoading = 'Loading Hub Zone...'
      if(data.hubid)
      {
        this.input = ({
          id: data.hubid
        })
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/hub/get',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
          this.HubZoneListDataForUpdate = result.data.ResponseData[0];
          this.hubItemForUpdate={
            value: this.HubZoneListDataForUpdate.HubID,
            text: this.HubZoneListDataForUpdate.HubName
          };

          this.hubzoneitemForUpdate={
            value: this.HubZoneListDataForUpdate.HubZoneId,
            text: this.HubZoneListDataForUpdate.hubzonename
          };
        }
        else{
          this.HubZoneListDataForUpdate = []
        }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })
      this.rackNumberForUpdate=data.rackname;
		},
		closeUpdateRackModal(){
      this.rackNoError=false;
      this.rackNoErrorMSG='';
			this.updateModal = false
      this.rackNumberForUpdate=''
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
			this.getRackList()
		},
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return false;
        } else {
          this.saveRack();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    resetFlt() {
      this.totalRows=0
      this.RackListData=[]
      this.hubzoneidflt1 = ''
      this.hubFlt = '',
        this.hubitemFlt = {
          value: '',
          text: ''
        },
        this.listHubZoneObjDataFlt1 = {
          value: '',
          text: ''
        }
        this.$validator.reset();
    },
    onSubmitFlt: function(Flt) {
      this.$validator.validateAll('Flt').then((result) => {
        if (!result) {
          return false;
        } else {
          this.getRackList();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    openStatusModal(data) {
      this.statusmodal = true
      this.modalDataForStatus = data
    },
    closeStatusModal() {
      this.statusmodal = false,
      this.modalDataForStatus=[],
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.getRackList();
    },
    UpdateRackStatus(){
      var newStatus=this.modalDataForStatus.isactive?0:1;
      this.input = ({
        "rackMasterId": this.modalDataForStatus.rackmasterid,
        "isActive": newStatus,
        "LastModifiedBy":this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateRackStatus',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeStatusModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/components/rackMaster/rackMaster.js